import React, {Component} from 'react';
import HeadlinesPicker from './headlines-picker';
import {withStyles} from '@material-ui/core';
import {styles} from './styles';

interface Classes {
    editorButtonWrapper: string;
    editorButton: string;
}

interface Props {
    onOverrideContent: (arg: any) => void;
    classes: Classes;
}

class HeadlinesButton extends Component<Props> {
    onMouseDown = (e: React.SyntheticEvent) => e.preventDefault();

    onClick = () => this.props.onOverrideContent(HeadlinesPicker);

    render() {
        const {classes} = this.props;
        return (
            <div onMouseDown={this.onMouseDown} className={classes.editorButtonWrapper}>
                <button onClick={this.onClick}
                    className={classes.editorButton}>
                    H
                </button>
            </div>
        );
    }
}

export default withStyles(styles)(HeadlinesButton);
